export default "__VITE_ASSET__BORHH7rA__"